import { useMemo, useState } from "react";
import type { FormEvent } from "react";
import { Aviso, Botao, Campo, Cartao } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  useCadastrarDominio,
  useDominios,
  useOrganizacoesParaCanais,
  useRemoverDominio,
} from "../../nucleo/canais";
import { CampoDeEscolha } from "../automacao/apoio";
import { useVoltarParaHome } from "../../nucleo/voltarParaHome";

export function PainelDeDominios() {
  const dominios = useDominios();
  const organizacoes = useOrganizacoesParaCanais();
  const cadastrar = useCadastrarDominio();
  const voltarParaHome = useVoltarParaHome();
  const remover = useRemoverDominio();
  const [organizacaoId, setOrganizacaoId] = useState("");
  const [dominio, setDominio] = useState("");
  const [problema, setProblema] = useState<string | null>(null);

  const nomes = useMemo(
    () => Object.fromEntries((organizacoes.data ?? []).map((o) => [o.id, o.nome_fantasia ?? o.razao_social])),
    [organizacoes.data],
  );

  function submeter(evento: FormEvent) {
    evento.preventDefault();
    const erro = !organizacaoId
      ? "Escolha a empresa."
      : dominio.trim().length < 3 || !dominio.includes(".")
        ? "Informe o domínio, como empresa.com.br."
        : null;
    setProblema(erro);
    if (erro) return;
    cadastrar.mutate(
      { organizacao_id: organizacaoId, dominio: dominio.trim() },
      {
        onSuccess: () => {
          setDominio("");
          voltarParaHome("Domínio de e-mail cadastrado.");
        },
      },
    );
  }

  const falha = cadastrar.error ?? remover.error ?? dominios.error;

  return (
    <div>
      <Cartao titulo="Novo domínio de e-mail" className="mb-4">
        <p className="nota-rodape mb-3">
          Um e-mail de quem não tem conta só abre chamado se o domínio dele estiver cadastrado aqui para uma
          empresa. Domínio de provedor público (Gmail, Outlook…) não pode ser cadastrado.
        </p>
        <form onSubmit={submeter} data-testid="formulario-de-dominio" noValidate>
          <CampoDeEscolha
            rotulo="Empresa"
            valor={organizacaoId}
            aoMudar={setOrganizacaoId}
            vazio="Escolha a empresa"
            opcoes={(organizacoes.data ?? []).map((o) => ({ valor: o.id, rotulo: o.nome_fantasia ?? o.razao_social }))}
          />
          <Campo rotulo="Domínio" value={dominio} onChange={(e) => setDominio(e.target.value)} placeholder="empresa.com.br" />
          {problema ? <Aviso tom="erro" className="mb-3">{problema}</Aviso> : null}
          {falha ? <Aviso tom="erro" className="mb-3">{mensagemDoConsole(falha)}</Aviso> : null}
          <Botao type="submit" disabled={cadastrar.isPending}>{cadastrar.isPending ? "Cadastrando…" : "Cadastrar domínio"}</Botao>
        </form>
      </Cartao>
      <section aria-labelledby="titulo-dominios">
        <h2 className="titulo-secao" id="titulo-dominios">Domínios cadastrados</h2>
        {dominios.data && dominios.data.length === 0 ? <Aviso tom="marca">Nenhum domínio cadastrado.</Aviso> : null}
        <ul className="lista-de-itens" data-testid="lista-de-dominios">
          {dominios.data?.map((item) => (
            <li key={item.id}>
              <code>{item.dominio}</code> · {nomes[item.organizacao_id] ?? "empresa"}{" "}
              <Botao
                type="button"
                variante="fantasma"
                tamanho="pequeno"
                aria-label={`Remover o domínio ${item.dominio}`}
                onClick={() => remover.mutate(item.id)}
              >
                Remover
              </Botao>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
